// **********************************************************************
// This file was generated by a TAF parser!
// TAF version 2.1.7.7
// Generated from `1650859629326.jce'
// **********************************************************************
import { Taf } from "@huyafed/taf-network";

const HUYA =  {};


HUYA.VideoDefinition = function()
{
    this.sSize = "";
    this.sWidth = "";
    this.sHeight = "";
    this.sDefinition = "";
    this.sUrl = "";
    this.sM3u8 = "";
    this.sDefName = "";
    this.sTs1Url = "";
    this.sTs1Offset = "";
    this.iLineIndex = 0;
};
HUYA.VideoDefinition.prototype._clone = function () { return new HUYA.VideoDefinition(); }
HUYA.VideoDefinition.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.VideoDefinition.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.VideoDefinition.prototype.writeTo = function (os)
{
    os.writeString(0, this.sSize);
    os.writeString(1, this.sWidth);
    os.writeString(2, this.sHeight);
    os.writeString(3, this.sDefinition);
    os.writeString(4, this.sUrl);
    os.writeString(5, this.sM3u8);
    os.writeString(6, this.sDefName);
    os.writeString(7, this.sTs1Url);
    os.writeString(8, this.sTs1Offset);
    os.writeInt32(9, this.iLineIndex);
};

HUYA.VideoDefinition.prototype.readFrom = function (is)
{
    this.sSize= is.readString(0, false, this.sSize);
    this.sWidth= is.readString(1, false, this.sWidth);
    this.sHeight= is.readString(2, false, this.sHeight);
    this.sDefinition= is.readString(3, false, this.sDefinition);
    this.sUrl= is.readString(4, false, this.sUrl);
    this.sM3u8= is.readString(5, false, this.sM3u8);
    this.sDefName= is.readString(6, false, this.sDefName);
    this.sTs1Url= is.readString(7, false, this.sTs1Url);
    this.sTs1Offset= is.readString(8, false, this.sTs1Offset);
    this.iLineIndex= is.readInt32(9, false, this.iLineIndex);
};

HUYA.MomentUrl = function()
{
    this.sCover = "";
    this.sUrl = "";
    this.iDirection = 0;
    this.iDuration = 0;
    this.sFileMD5 = "";
    this.sText = "";
};
HUYA.MomentUrl.prototype._clone = function () { return new HUYA.MomentUrl(); }
HUYA.MomentUrl.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.MomentUrl.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.MomentUrl.prototype.writeTo = function (os)
{
    os.writeString(0, this.sCover);
    os.writeString(1, this.sUrl);
    os.writeInt32(2, this.iDirection);
    os.writeInt32(3, this.iDuration);
    os.writeString(4, this.sFileMD5);
    os.writeString(5, this.sText);
};

HUYA.MomentUrl.prototype.readFrom = function (is)
{
    this.sCover= is.readString(0, false, this.sCover);
    this.sUrl= is.readString(1, false, this.sUrl);
    this.iDirection= is.readInt32(2, false, this.iDirection);
    this.iDuration= is.readInt32(3, false, this.iDuration);
    this.sFileMD5= is.readString(4, false, this.sFileMD5);
    this.sText= is.readString(5, false, this.sText);
};

HUYA.MomentAtContent = function()
{
    this.lAtUid = 0;
    this.sAtNick = "";
    this.iBegin = 0;
    this.iEnd = 0;
};
HUYA.MomentAtContent.prototype._clone = function () { return new HUYA.MomentAtContent(); }
HUYA.MomentAtContent.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.MomentAtContent.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.MomentAtContent.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lAtUid);
    os.writeString(1, this.sAtNick);
    os.writeInt32(2, this.iBegin);
    os.writeInt32(3, this.iEnd);
};

HUYA.MomentAtContent.prototype.readFrom = function (is)
{
    this.lAtUid= is.readInt64(0, false, this.lAtUid);
    this.sAtNick= is.readString(1, false, this.sAtNick);
    this.iBegin= is.readInt32(2, false, this.iBegin);
    this.iEnd= is.readInt32(3, false, this.iEnd);
};

HUYA.CommentCornerMark = function()
{
    this.iId = 0;
    this.sContent = "";
};
HUYA.CommentCornerMark.prototype._clone = function () { return new HUYA.CommentCornerMark(); }
HUYA.CommentCornerMark.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.CommentCornerMark.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.CommentCornerMark.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iId);
    os.writeString(1, this.sContent);
};

HUYA.CommentCornerMark.prototype.readFrom = function (is)
{
    this.iId= is.readInt32(0, false, this.iId);
    this.sContent= is.readString(1, false, this.sContent);
};

HUYA.CommentAttach = function()
{
    this.iType = 0;
    this.sContent = "";
    this.sFileMD5 = "";
};
HUYA.CommentAttach.prototype._clone = function () { return new HUYA.CommentAttach(); }
HUYA.CommentAttach.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.CommentAttach.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.CommentAttach.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iType);
    os.writeString(1, this.sContent);
    os.writeString(2, this.sFileMD5);
};

HUYA.CommentAttach.prototype.readFrom = function (is)
{
    this.iType= is.readInt32(0, false, this.iType);
    this.sContent= is.readString(1, false, this.sContent);
    this.sFileMD5= is.readString(2, false, this.sFileMD5);
};

HUYA.VideoInfo = function()
{
    this.lUid = 0;
    this.sAvatarUrl = "";
    this.sNickName = "";
    this.lVid = 0;
    this.sVideoTitle = "";
    this.sVideoCover = "";
    this.lVideoPlayNum = 0;
    this.lVideoCommentNum = 0;
    this.sVideoDuration = "";
    this.sVideoUrl = "";
    this.sVideoUploadTime = "";
    this.sVideoChannel = "";
    this.sCategory = "";
    this.vDefinitions = new Taf.Vector(new HUYA.VideoDefinition());
    this.iVideoRecommend = 0;
    this.bVideoDot = true;
    this.lVideoRank = 0;
    this.bVideoHasRanked = true;
    this.sTraceId = "";
    this.lActorUid = 0;
    this.sActorNick = "";
    this.sActorAvatarUrl = "";
    this.iExtPlayTimes = 0;
    this.sVideoBigCover = "";
    this.iCommentCount = 0;
    this.vTags = new Taf.Vector(new Taf.STRING());
    this.iVideoDirection = 0;
    this.sBriefIntroduction = "";
    this.iVideoType = 0;
    this.iFavorCount = 0;
    this.lMomId = 0;
    this.sSubTitle = "";
    this.mMiscData = new Taf.Map(new Taf.STRING(), new Taf.STRING());
};
HUYA.VideoInfo.prototype._clone = function () { return new HUYA.VideoInfo(); }
HUYA.VideoInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.VideoInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.VideoInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sAvatarUrl);
    os.writeString(2, this.sNickName);
    os.writeInt64(3, this.lVid);
    os.writeString(4, this.sVideoTitle);
    os.writeString(5, this.sVideoCover);
    os.writeInt64(6, this.lVideoPlayNum);
    os.writeInt64(7, this.lVideoCommentNum);
    os.writeString(8, this.sVideoDuration);
    os.writeString(9, this.sVideoUrl);
    os.writeString(10, this.sVideoUploadTime);
    os.writeString(11, this.sVideoChannel);
    os.writeString(12, this.sCategory);
    os.writeVector(13, this.vDefinitions);
    os.writeInt32(14, this.iVideoRecommend);
    os.writeBoolean(15, this.bVideoDot);
    os.writeInt64(16, this.lVideoRank);
    os.writeBoolean(17, this.bVideoHasRanked);
    os.writeString(18, this.sTraceId);
    os.writeInt64(19, this.lActorUid);
    os.writeString(20, this.sActorNick);
    os.writeString(21, this.sActorAvatarUrl);
    os.writeInt32(22, this.iExtPlayTimes);
    os.writeString(23, this.sVideoBigCover);
    os.writeInt32(24, this.iCommentCount);
    os.writeVector(25, this.vTags);
    os.writeInt32(26, this.iVideoDirection);
    os.writeString(27, this.sBriefIntroduction);
    os.writeInt32(28, this.iVideoType);
    os.writeInt32(29, this.iFavorCount);
    os.writeInt64(30, this.lMomId);
    os.writeString(31, this.sSubTitle);
    os.writeMap(32, this.mMiscData);
};

HUYA.VideoInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sAvatarUrl= is.readString(1, false, this.sAvatarUrl);
    this.sNickName= is.readString(2, false, this.sNickName);
    this.lVid= is.readInt64(3, false, this.lVid);
    this.sVideoTitle= is.readString(4, false, this.sVideoTitle);
    this.sVideoCover= is.readString(5, false, this.sVideoCover);
    this.lVideoPlayNum= is.readInt64(6, false, this.lVideoPlayNum);
    this.lVideoCommentNum= is.readInt64(7, false, this.lVideoCommentNum);
    this.sVideoDuration= is.readString(8, false, this.sVideoDuration);
    this.sVideoUrl= is.readString(9, false, this.sVideoUrl);
    this.sVideoUploadTime= is.readString(10, false, this.sVideoUploadTime);
    this.sVideoChannel= is.readString(11, false, this.sVideoChannel);
    this.sCategory= is.readString(12, false, this.sCategory);
    this.vDefinitions= is.readVector(13, false, this.vDefinitions);
    this.iVideoRecommend= is.readInt32(14, false, this.iVideoRecommend);
    this.bVideoDot= is.readBoolean(15, false, this.bVideoDot);
    this.lVideoRank= is.readInt64(16, false, this.lVideoRank);
    this.bVideoHasRanked= is.readBoolean(17, false, this.bVideoHasRanked);
    this.sTraceId= is.readString(18, false, this.sTraceId);
    this.lActorUid= is.readInt64(19, false, this.lActorUid);
    this.sActorNick= is.readString(20, false, this.sActorNick);
    this.sActorAvatarUrl= is.readString(21, false, this.sActorAvatarUrl);
    this.iExtPlayTimes= is.readInt32(22, false, this.iExtPlayTimes);
    this.sVideoBigCover= is.readString(23, false, this.sVideoBigCover);
    this.iCommentCount= is.readInt32(24, false, this.iCommentCount);
    this.vTags= is.readVector(25, false, this.vTags);
    this.iVideoDirection= is.readInt32(26, false, this.iVideoDirection);
    this.sBriefIntroduction= is.readString(27, false, this.sBriefIntroduction);
    this.iVideoType= is.readInt32(28, false, this.iVideoType);
    this.iFavorCount= is.readInt32(29, false, this.iFavorCount);
    this.lMomId= is.readInt64(30, false, this.lMomId);
    this.sSubTitle= is.readString(31, false, this.sSubTitle);
    this.mMiscData= is.readMap(32, false, this.mMiscData);
};

HUYA.MomentDecorationItem = function()
{
    this.iType = 0;
    this.vData = new Taf.BinBuffer();
};
HUYA.MomentDecorationItem.prototype._clone = function () { return new HUYA.MomentDecorationItem(); }
HUYA.MomentDecorationItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.MomentDecorationItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.MomentDecorationItem.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iType);
    os.writeBytes(1, this.vData);
};

HUYA.MomentDecorationItem.prototype.readFrom = function (is)
{
    this.iType= is.readInt32(0, false, this.iType);
    this.vData= is.readBytes(1, false, this.vData);
};

HUYA.MomentAttachment = function()
{
    this.iType = 0;
    this.sContent = "";
    this.sUrl = new Taf.Vector(new HUYA.MomentUrl());
    this.iDataType = 0;
    this.sData = new Taf.BinBuffer();
    this.vAtContent = new Taf.Vector(new HUYA.MomentAtContent());
    this.vAttachLink = new Taf.Vector(new Taf.STRING());
    this.sVoteId = "";
    this.lVideoId = 0;
    this.vAction = new Taf.Vector(new HUYA.MomentUrl());
};
HUYA.MomentAttachment.prototype._clone = function () { return new HUYA.MomentAttachment(); }
HUYA.MomentAttachment.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.MomentAttachment.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.MomentAttachment.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iType);
    os.writeString(1, this.sContent);
    os.writeVector(2, this.sUrl);
    os.writeInt32(3, this.iDataType);
    os.writeBytes(4, this.sData);
    os.writeVector(5, this.vAtContent);
    os.writeVector(6, this.vAttachLink);
    os.writeString(7, this.sVoteId);
    os.writeInt64(8, this.lVideoId);
    os.writeVector(9, this.vAction);
};

HUYA.MomentAttachment.prototype.readFrom = function (is)
{
    this.iType= is.readInt32(0, false, this.iType);
    this.sContent= is.readString(1, false, this.sContent);
    this.sUrl= is.readVector(2, false, this.sUrl);
    this.iDataType= is.readInt32(3, false, this.iDataType);
    this.sData= is.readBytes(4, false, this.sData);
    this.vAtContent= is.readVector(5, false, this.vAtContent);
    this.vAttachLink= is.readVector(6, false, this.vAttachLink);
    this.sVoteId= is.readString(7, false, this.sVoteId);
    this.lVideoId= is.readInt64(8, false, this.lVideoId);
    this.vAction= is.readVector(9, false, this.vAction);
};

HUYA.CommentInfo = function()
{
    this.lComId = 0;
    this.lParentId = 0;
    this.lMomId = 0;
    this.lUid = 0;
    this.sNickName = "";
    this.sIconUrl = "";
    this.sContent = "";
    this.iCTime = 0;
    this.iFavorCount = 0;
    this.iReplyCount = 0;
    this.vComment = new Taf.Vector(HUYA.CommentInfo);
    this.lReplyToComId = 0;
    this.lReplyToUid = 0;
    this.sReplyToNickName = "";
    this.iStatus = 0;
    this.iOpt = 0;
    this.iFavoredByOnwer = 0;
    this.iTopStatus = 0;
    this.vCommentAttach = new Taf.Vector(new HUYA.CommentAttach());
    this.vTags = new Taf.Vector(new Taf.STRING());
    this.vCornerMark = new Taf.Vector(new HUYA.CommentCornerMark());
};
HUYA.CommentInfo.prototype._clone = function () { return new HUYA.CommentInfo(); }
HUYA.CommentInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.CommentInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.CommentInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lComId);
    os.writeInt64(1, this.lParentId);
    os.writeInt64(2, this.lMomId);
    os.writeInt64(3, this.lUid);
    os.writeString(4, this.sNickName);
    os.writeString(5, this.sIconUrl);
    os.writeString(6, this.sContent);
    os.writeInt32(7, this.iCTime);
    os.writeInt32(8, this.iFavorCount);
    os.writeInt32(9, this.iReplyCount);
    os.writeVector(10, this.vComment);
    os.writeInt64(11, this.lReplyToComId);
    os.writeInt64(12, this.lReplyToUid);
    os.writeString(13, this.sReplyToNickName);
    os.writeInt32(14, this.iStatus);
    os.writeInt32(15, this.iOpt);
    os.writeInt32(16, this.iFavoredByOnwer);
    os.writeInt32(20, this.iTopStatus);
    os.writeVector(21, this.vCommentAttach);
    os.writeVector(22, this.vTags);
    os.writeVector(23, this.vCornerMark);
};

HUYA.CommentInfo.prototype.readFrom = function (is)
{
    this.lComId= is.readInt64(0, false, this.lComId);
    this.lParentId= is.readInt64(1, false, this.lParentId);
    this.lMomId= is.readInt64(2, false, this.lMomId);
    this.lUid= is.readInt64(3, false, this.lUid);
    this.sNickName= is.readString(4, false, this.sNickName);
    this.sIconUrl= is.readString(5, false, this.sIconUrl);
    this.sContent= is.readString(6, false, this.sContent);
    this.iCTime= is.readInt32(7, false, this.iCTime);
    this.iFavorCount= is.readInt32(8, false, this.iFavorCount);
    this.iReplyCount= is.readInt32(9, false, this.iReplyCount);
    this.vComment= is.readVector(10, false, this.vComment);
    this.lReplyToComId= is.readInt64(11, false, this.lReplyToComId);
    this.lReplyToUid= is.readInt64(12, false, this.lReplyToUid);
    this.sReplyToNickName= is.readString(13, false, this.sReplyToNickName);
    this.iStatus= is.readInt32(14, false, this.iStatus);
    this.iOpt= is.readInt32(15, false, this.iOpt);
    this.iFavoredByOnwer= is.readInt32(16, false, this.iFavoredByOnwer);
    this.iTopStatus= is.readInt32(20, false, this.iTopStatus);
    this.vCommentAttach= is.readVector(21, false, this.vCommentAttach);
    this.vTags= is.readVector(22, false, this.vTags);
    this.vCornerMark= is.readVector(23, false, this.vCornerMark);
};

HUYA.UserBase = function()
{
    this.lUid = 0;
    this.sNickName = "";
    this.sAvatarUrl = "";
    this.iGender = 0;
    this.lYYId = 0;
    this.iCertified = 0;
    this.iSubscribedCount = 0;
    this.iSubscribeToCount = 0;
    this.iUserLevel = 0;
    this.lUserExp = 0;
    this.iBirthday = 0;
    this.sSign = "";
    this.sArea = "";
    this.sLocation = "";
    this.sRegisterTime = "";
    this.iFreezeTime = 0;
    this.iBindPhone = 0;
    this.sHuyaId = "";
    this.iModifyNickChannel = 0;
    this.iLogoutStatus = 0;
};
HUYA.UserBase.prototype._clone = function () { return new HUYA.UserBase(); }
HUYA.UserBase.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserBase.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserBase.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sNickName);
    os.writeString(2, this.sAvatarUrl);
    os.writeInt32(3, this.iGender);
    os.writeInt64(4, this.lYYId);
    os.writeInt32(5, this.iCertified);
    os.writeInt32(6, this.iSubscribedCount);
    os.writeInt32(7, this.iSubscribeToCount);
    os.writeInt32(8, this.iUserLevel);
    os.writeInt64(9, this.lUserExp);
    os.writeInt32(10, this.iBirthday);
    os.writeString(11, this.sSign);
    os.writeString(12, this.sArea);
    os.writeString(13, this.sLocation);
    os.writeString(14, this.sRegisterTime);
    os.writeInt32(15, this.iFreezeTime);
    os.writeInt32(16, this.iBindPhone);
    os.writeString(17, this.sHuyaId);
    os.writeInt32(18, this.iModifyNickChannel);
    os.writeInt32(20, this.iLogoutStatus);
};

HUYA.UserBase.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sNickName= is.readString(1, false, this.sNickName);
    this.sAvatarUrl= is.readString(2, false, this.sAvatarUrl);
    this.iGender= is.readInt32(3, false, this.iGender);
    this.lYYId= is.readInt64(4, false, this.lYYId);
    this.iCertified= is.readInt32(5, false, this.iCertified);
    this.iSubscribedCount= is.readInt32(6, false, this.iSubscribedCount);
    this.iSubscribeToCount= is.readInt32(7, false, this.iSubscribeToCount);
    this.iUserLevel= is.readInt32(8, false, this.iUserLevel);
    this.lUserExp= is.readInt64(9, false, this.lUserExp);
    this.iBirthday= is.readInt32(10, false, this.iBirthday);
    this.sSign= is.readString(11, false, this.sSign);
    this.sArea= is.readString(12, false, this.sArea);
    this.sLocation= is.readString(13, false, this.sLocation);
    this.sRegisterTime= is.readString(14, false, this.sRegisterTime);
    this.iFreezeTime= is.readInt32(15, false, this.iFreezeTime);
    this.iBindPhone= is.readInt32(16, false, this.iBindPhone);
    this.sHuyaId= is.readString(17, false, this.sHuyaId);
    this.iModifyNickChannel= is.readInt32(18, false, this.iModifyNickChannel);
    this.iLogoutStatus= is.readInt32(20, false, this.iLogoutStatus);
};

HUYA.MomentInfo = function()
{
    this.lMomId = 0;
    this.iType = 0;
    this.lUid = 0;
    this.sNickName = "";
    this.sIconUrl = "";
    this.sTitle = "";
    this.sContent = "";
    this.iFavorCount = 0;
    this.iCommentCount = 0;
    this.iShareCount = 0;
    this.vComment = new Taf.Vector(new HUYA.CommentInfo());
    this.iCTime = 0;
    this.iStatus = 0;
    this.iOpt = 0;
    this.tVideoInfo = new HUYA.VideoInfo();
    this.vKeyWord = new Taf.Vector(new Taf.STRING());
    this.iHasDraw = 0;
    this.vCoverUrl = new Taf.Vector(new Taf.STRING());
    this.sHtmlDoc = "";
    this.vTags = new Taf.Vector(new Taf.STRING());
    this.vBelongPlate = new Taf.Vector(new Taf.STRING());
    this.iBrowseCount = 0;
    this.iCardType = 0;
    this.vMomentAttachment = new Taf.Vector(new HUYA.MomentAttachment());
    this.iStepOnCount = 0;
    this.iUserOpt = 0;
    this.vMomentDecoration = new Taf.Vector(new HUYA.MomentDecorationItem());
    this.iTopStatus = 0;
};
HUYA.MomentInfo.prototype._clone = function () { return new HUYA.MomentInfo(); }
HUYA.MomentInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.MomentInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.MomentInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lMomId);
    os.writeInt32(1, this.iType);
    os.writeInt64(2, this.lUid);
    os.writeString(3, this.sNickName);
    os.writeString(4, this.sIconUrl);
    os.writeString(5, this.sTitle);
    os.writeString(6, this.sContent);
    os.writeInt32(7, this.iFavorCount);
    os.writeInt32(8, this.iCommentCount);
    os.writeInt32(9, this.iShareCount);
    os.writeVector(10, this.vComment);
    os.writeInt32(11, this.iCTime);
    os.writeInt32(12, this.iStatus);
    os.writeInt32(13, this.iOpt);
    os.writeStruct(14, this.tVideoInfo);
    os.writeVector(15, this.vKeyWord);
    os.writeInt32(16, this.iHasDraw);
    os.writeVector(17, this.vCoverUrl);
    os.writeString(18, this.sHtmlDoc);
    os.writeVector(19, this.vTags);
    os.writeVector(20, this.vBelongPlate);
    os.writeInt32(21, this.iBrowseCount);
    os.writeInt32(22, this.iCardType);
    os.writeVector(23, this.vMomentAttachment);
    os.writeInt32(24, this.iStepOnCount);
    os.writeInt32(25, this.iUserOpt);
    os.writeVector(26, this.vMomentDecoration);
    os.writeInt32(27, this.iTopStatus);
};

HUYA.MomentInfo.prototype.readFrom = function (is)
{
    this.lMomId= is.readInt64(0, false, this.lMomId);
    this.iType= is.readInt32(1, false, this.iType);
    this.lUid= is.readInt64(2, false, this.lUid);
    this.sNickName= is.readString(3, false, this.sNickName);
    this.sIconUrl= is.readString(4, false, this.sIconUrl);
    this.sTitle= is.readString(5, false, this.sTitle);
    this.sContent= is.readString(6, false, this.sContent);
    this.iFavorCount= is.readInt32(7, false, this.iFavorCount);
    this.iCommentCount= is.readInt32(8, false, this.iCommentCount);
    this.iShareCount= is.readInt32(9, false, this.iShareCount);
    this.vComment= is.readVector(10, false, this.vComment);
    this.iCTime= is.readInt32(11, false, this.iCTime);
    this.iStatus= is.readInt32(12, false, this.iStatus);
    this.iOpt= is.readInt32(13, false, this.iOpt);
    this.tVideoInfo= is.readStruct(14, false, this.tVideoInfo);
    this.vKeyWord= is.readVector(15, false, this.vKeyWord);
    this.iHasDraw= is.readInt32(16, false, this.iHasDraw);
    this.vCoverUrl= is.readVector(17, false, this.vCoverUrl);
    this.sHtmlDoc= is.readString(18, false, this.sHtmlDoc);
    this.vTags= is.readVector(19, false, this.vTags);
    this.vBelongPlate= is.readVector(20, false, this.vBelongPlate);
    this.iBrowseCount= is.readInt32(21, false, this.iBrowseCount);
    this.iCardType= is.readInt32(22, false, this.iCardType);
    this.vMomentAttachment= is.readVector(23, false, this.vMomentAttachment);
    this.iStepOnCount= is.readInt32(24, false, this.iStepOnCount);
    this.iUserOpt= is.readInt32(25, false, this.iUserOpt);
    this.vMomentDecoration= is.readVector(26, false, this.vMomentDecoration);
    this.iTopStatus= is.readInt32(27, false, this.iTopStatus);
};

HUYA.VideoTopic = function()
{
    this.iTopicId = 0;
    this.sTopicTitle = "";
    this.iTopicVideoNum = 0;
    this.sTopicCover = "";
    this.sTopicVideoTitle = "";
    this.sTopicUrl = "";
    this.vVideoMoments = new Taf.Vector(new HUYA.MomentInfo());
    this.vRelatedPid = new Taf.Vector(new Taf.INT64());
    this.sTopicBrief = "";
    this.iTopicViews = 0;
    this.iTopicComments = 0;
    this.iWeight = 0;
    this.sShortTitle = "";
    this.iEnableHotSort = 0;
    this.sDetailUrl = "";
    this.vSort = new Taf.Vector(new Taf.INT32());
    this.iDefaultSort = 0;
    this.sCatagray = "";
    this.iRankType = 0;
    this.sTag = "";
    this.vTalker = new Taf.Vector(new HUYA.UserBase());
    this.iDisplayEnchance = 0;
    this.vRelatedKeyword = new Taf.Vector(new Taf.STRING());
    this.iTemplateType = 0;
};
HUYA.VideoTopic.prototype._clone = function () { return new HUYA.VideoTopic(); }
HUYA.VideoTopic.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.VideoTopic.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.VideoTopic.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iTopicId);
    os.writeString(1, this.sTopicTitle);
    os.writeInt32(2, this.iTopicVideoNum);
    os.writeString(3, this.sTopicCover);
    os.writeString(4, this.sTopicVideoTitle);
    os.writeString(5, this.sTopicUrl);
    os.writeVector(6, this.vVideoMoments);
    os.writeVector(7, this.vRelatedPid);
    os.writeString(8, this.sTopicBrief);
    os.writeInt32(9, this.iTopicViews);
    os.writeInt32(10, this.iTopicComments);
    os.writeInt32(11, this.iWeight);
    os.writeString(12, this.sShortTitle);
    os.writeInt32(13, this.iEnableHotSort);
    os.writeString(14, this.sDetailUrl);
    os.writeVector(15, this.vSort);
    os.writeInt32(16, this.iDefaultSort);
    os.writeString(17, this.sCatagray);
    os.writeInt32(18, this.iRankType);
    os.writeString(19, this.sTag);
    os.writeVector(20, this.vTalker);
    os.writeInt32(21, this.iDisplayEnchance);
    os.writeVector(22, this.vRelatedKeyword);
    os.writeInt32(23, this.iTemplateType);
};

HUYA.VideoTopic.prototype.readFrom = function (is)
{
    this.iTopicId= is.readInt32(0, false, this.iTopicId);
    this.sTopicTitle= is.readString(1, false, this.sTopicTitle);
    this.iTopicVideoNum= is.readInt32(2, false, this.iTopicVideoNum);
    this.sTopicCover= is.readString(3, false, this.sTopicCover);
    this.sTopicVideoTitle= is.readString(4, false, this.sTopicVideoTitle);
    this.sTopicUrl= is.readString(5, false, this.sTopicUrl);
    this.vVideoMoments= is.readVector(6, false, this.vVideoMoments);
    this.vRelatedPid= is.readVector(7, false, this.vRelatedPid);
    this.sTopicBrief= is.readString(8, false, this.sTopicBrief);
    this.iTopicViews= is.readInt32(9, false, this.iTopicViews);
    this.iTopicComments= is.readInt32(10, false, this.iTopicComments);
    this.iWeight= is.readInt32(11, false, this.iWeight);
    this.sShortTitle= is.readString(12, false, this.sShortTitle);
    this.iEnableHotSort= is.readInt32(13, false, this.iEnableHotSort);
    this.sDetailUrl= is.readString(14, false, this.sDetailUrl);
    this.vSort= is.readVector(15, false, this.vSort);
    this.iDefaultSort= is.readInt32(16, false, this.iDefaultSort);
    this.sCatagray= is.readString(17, false, this.sCatagray);
    this.iRankType= is.readInt32(18, false, this.iRankType);
    this.sTag= is.readString(19, false, this.sTag);
    this.vTalker= is.readVector(20, false, this.vTalker);
    this.iDisplayEnchance= is.readInt32(21, false, this.iDisplayEnchance);
    this.vRelatedKeyword= is.readVector(22, false, this.vRelatedKeyword);
    this.iTemplateType= is.readInt32(23, false, this.iTemplateType);
};

HUYA.VideoGroupPresenterItem = function()
{
    this.vUser = new Taf.Vector(new HUYA.UserBase());
    this.sAction = "";
    this.iTotal = 0;
};
HUYA.VideoGroupPresenterItem.prototype._clone = function () { return new HUYA.VideoGroupPresenterItem(); }
HUYA.VideoGroupPresenterItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.VideoGroupPresenterItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.VideoGroupPresenterItem.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vUser);
    os.writeString(1, this.sAction);
    os.writeInt32(2, this.iTotal);
};

HUYA.VideoGroupPresenterItem.prototype.readFrom = function (is)
{
    this.vUser= is.readVector(0, false, this.vUser);
    this.sAction= is.readString(1, false, this.sAction);
    this.iTotal= is.readInt32(2, false, this.iTotal);
};

HUYA.VideoGroupMomentItem = function()
{
    this.tMoment = new HUYA.MomentInfo();
    this.iWidth = 0;
    this.iHeight = 0;
};
HUYA.VideoGroupMomentItem.prototype._clone = function () { return new HUYA.VideoGroupMomentItem(); }
HUYA.VideoGroupMomentItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.VideoGroupMomentItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.VideoGroupMomentItem.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tMoment);
    os.writeInt32(1, this.iWidth);
    os.writeInt32(2, this.iHeight);
};

HUYA.VideoGroupMomentItem.prototype.readFrom = function (is)
{
    this.tMoment= is.readStruct(0, false, this.tMoment);
    this.iWidth= is.readInt32(1, false, this.iWidth);
    this.iHeight= is.readInt32(2, false, this.iHeight);
};

HUYA.VidoGroupListItem = function()
{
    this.iDataType = 0;
    this.tMoment = new HUYA.VideoGroupMomentItem();
    this.tPresenter = new HUYA.VideoGroupPresenterItem();
    this.tTopic = new HUYA.VideoTopic();
};
HUYA.VidoGroupListItem.prototype._clone = function () { return new HUYA.VidoGroupListItem(); }
HUYA.VidoGroupListItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.VidoGroupListItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.VidoGroupListItem.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iDataType);
    os.writeStruct(1, this.tMoment);
    os.writeStruct(2, this.tPresenter);
    os.writeStruct(3, this.tTopic);
};

HUYA.VidoGroupListItem.prototype.readFrom = function (is)
{
    this.iDataType= is.readInt32(0, false, this.iDataType);
    this.tMoment= is.readStruct(1, false, this.tMoment);
    this.tPresenter= is.readStruct(2, false, this.tPresenter);
    this.tTopic= is.readStruct(3, false, this.tTopic);
};

HUYA.UserId = function()
{
    this.lUid = 0;
    this.sGuid = "";
    this.sToken = "";
    this.sHuYaUA = "";
    this.sCookie = "";
    this.iTokenType = 0;
    this.sDeviceInfo = "";
};
HUYA.UserId.prototype._clone = function () { return new HUYA.UserId(); }
HUYA.UserId.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserId.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserId.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sGuid);
    os.writeString(2, this.sToken);
    os.writeString(3, this.sHuYaUA);
    os.writeString(4, this.sCookie);
    os.writeInt32(5, this.iTokenType);
    os.writeString(6, this.sDeviceInfo);
};

HUYA.UserId.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sGuid= is.readString(1, false, this.sGuid);
    this.sToken= is.readString(2, false, this.sToken);
    this.sHuYaUA= is.readString(3, false, this.sHuYaUA);
    this.sCookie= is.readString(4, false, this.sCookie);
    this.iTokenType= is.readInt32(5, false, this.iTokenType);
    this.sDeviceInfo= is.readString(6, false, this.sDeviceInfo);
};

HUYA.GetGroupListByIdRsp = function()
{
    this.vGroupListItem = new Taf.Vector(new HUYA.VidoGroupListItem());
    this.iHasMore = 0;
};
HUYA.GetGroupListByIdRsp.prototype._clone = function () { return new HUYA.GetGroupListByIdRsp(); }
HUYA.GetGroupListByIdRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetGroupListByIdRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetGroupListByIdRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vGroupListItem);
    os.writeInt32(1, this.iHasMore);
};

HUYA.GetGroupListByIdRsp.prototype.readFrom = function (is)
{
    this.vGroupListItem= is.readVector(0, false, this.vGroupListItem);
    this.iHasMore= is.readInt32(1, false, this.iHasMore);
};

HUYA.GetGroupListByIdReq = function()
{
    this.tId = new HUYA.UserId();
    this.iListId = 0;
    this.iPage = 0;
    this.iFreeFlowFlag = 0;
};
HUYA.GetGroupListByIdReq.prototype._clone = function () { return new HUYA.GetGroupListByIdReq(); }
HUYA.GetGroupListByIdReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GetGroupListByIdReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GetGroupListByIdReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt32(1, this.iListId);
    os.writeInt32(2, this.iPage);
    os.writeInt32(3, this.iFreeFlowFlag);
};

HUYA.GetGroupListByIdReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.iListId= is.readInt32(1, false, this.iListId);
    this.iPage= is.readInt32(2, false, this.iPage);
    this.iFreeFlowFlag= is.readInt32(3, false, this.iFreeFlowFlag);
};

export default HUYA;